import { Box, Stack, Typography, IconButton } from '@mui/material';
import { Icon } from '@iconify/react';

interface InvoicesProps {
  onBack: () => void;
}

const Invoices = ({ onBack }: InvoicesProps) => {
  return (
    <Stack 
      sx={{ 
        width: '100%', 
        height: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'relative'
      }}
    >
      {/* Заголовок с кнопкой назад */}
      <Stack 
        direction="row" 
        justifyContent="space-between" 
        alignItems="center"
        sx={{ 
          width: '100%',
          mb: 3,
        }}
      >
        <IconButton 
          onClick={onBack}
          sx={{ 
            p: 0.5,
          }}
        >
          <Icon icon="material-symbols:arrow-forward-ios" width="20px" color="#666" />
        </IconButton>
        <Typography
          fontWeight={'700'}
          fontSize={'24px'}
          fontFamily={'AlmoniDL'}
          textAlign="right"
          color={'#424245'}
        >
          החשבוניות שלי
        </Typography>
      </Stack>

      {/* Основной контент */}
      <Stack spacing={2} sx={{ width: '100%', alignItems: 'center', flex: 1 }}>
        {/* Иконка */}
        <Box sx={{ mb: 2 }}>
          <Icon 
            icon="material-symbols:receipt-long" 
            width="80px" 
            height="80px" 
            color="#C1FE40" 
          />
        </Box>

        {/* Заголовок */}
        <Typography
          fontWeight={'700'}
          fontSize={'20px'}
          fontFamily={'AlmoniDL'}
          color={'#424245'}
          textAlign="center"
          sx={{ mb: 1 }}
        >
          החשבוניות שלי
        </Typography>

        {/* Описание */}
        <Typography
          fontWeight={'400'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
          color={'#808080'}
          textAlign="center"
          sx={{ maxWidth: '280px', lineHeight: 1.5 }}
        >
          כאן תוכל לראות את כל החשבוניות שלך, לנהל אותן ולעקוב אחר הסטטוס שלהן
        </Typography>

        {/* Placeholder для списка счетов */}
        <Stack spacing={1} sx={{ width: '100%', mt: 3 }}>
          {/* Пример элемента счета */}
          <Box
            sx={{
              width: '100%',
              p: 2,
              bgcolor: '#F8F9FA',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
              >
                1.3.2025
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
                textAlign="right"
              >
                חשבונית מס׳ 2025
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#7AED20'}
              >
                ₪30
              </Typography>
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
                textAlign="right"
              >
                סכום
              </Typography>
            </Stack>
          </Box>

          {/* Еще несколько примеров */}
          <Box
            sx={{
              width: '100%',
              p: 2,
              bgcolor: '#F8F9FA',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
              >
                1.3.2025
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
                textAlign="right"
              >
                חשבונית מס׳ 2024
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#7AED20'}
              >
                ₪30
              </Typography>
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
                textAlign="right"
              >
                סכום
              </Typography>
            </Stack>
          </Box>

          <Box
            sx={{
              width: '100%',
              p: 2,
              bgcolor: '#F8F9FA',
              borderRadius: '12px',
              border: '1px solid #E5E7EB',
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
              >
                1.3.2025
              </Typography>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#424245'}
                textAlign="right"
              >
                חשבונית מס׳ 2023
              </Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mt: 0.5 }}>
              <Typography
                fontWeight={'700'}
                fontSize={'14px'}
                fontFamily={'AlmoniDL'}
                color={'#7AED20'}
              >
                ₪30
              </Typography>
              <Typography
                fontWeight={'400'}
                fontSize={'12px'}
                fontFamily={'AlmoniDL'}
                color={'#808080'}
                textAlign="right"
              >
                סכום
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Invoices;
